import { updateMetaTags } from '../../utils/meta-tags-updater';
import { useEffect, useState } from "react";
import { Box, CardMedia, Container, Stack, Typography } from "@mui/material";
import MusicPlayer from "../player/MusicPlayer"
import { API } from '../../interceptors/axios'
import { useParams } from "react-router-dom";
import { fetchAuth } from '../../utils/auth';
import { encrypt } from '../../utils/encryption';
// import { isSocialMediaPreview, getSocialPlatform } from '../../utils/social-media-detector';



const Details = ({sendPage}) => {

  // const [songId, setSongId] = useState(0)
  const [songUrl, setSongUrl] = useState([])  
  const [imageUrl, setImageUrl] = useState()
  const [blogData, setBlogData] = useState([])
  const [smallImageUrl, setSmallImageUrl] = useState(); // Add this line
  const [isLoading, setLoading] = useState(true)

  let {slug} = useParams('')

  // Get these values immediately, don't wait for useEffect
  const songId = slug.split('-').slice(-1)[0]; // Extract last element from slug as songId
  const songTitle = slug.split('-').slice(0, -1).join('-'); // Extract title from slug
  
  // Pre-set meta tags immediately for crawlers
  // if (typeof window !== 'undefined' && isSocialMediaPreview()) {
  //   console.log("Pre-setting meta tags for details page crawler");
  //   const platform = getSocialPlatform();
  //   const publicPreviewUrl = `${process.env.REACT_APP_API_URL}/public-preview/${songId}.jpg?v=${Date.now()}`;
    
  //   updateMetaTags({
  //     title: 'Distorise Music - ' + songTitle.replace(/-/g, ' '),
  //     description: 'Listen to this track on Distorise Music Blog',
  //     imageUrl: publicPreviewUrl,
  //     pageUrl: window.location.href,
  //     type: 'music.song'
  //   });
    
  //   console.log(`Bot meta tags pre-set for ${platform || 'unknown'} with URL: ${publicPreviewUrl}`);
  // }


  const fetchAudioStream = async (songId) => {
      try {
          await fetchAuth();
          const token = localStorage.getItem('token');
          
          if (!token) {
              throw new Error('No authorization token found');
          }

          // Get encrypted service credentials
          const encryptedService = encrypt(process.env.REACT_APP_SERVICE_NAME);
          const encryptedKey = encrypt(process.env.REACT_APP_SERVICE_KEY);

          // Create URL with all required parameters
          const url = new URL(`${process.env.REACT_APP_API_URL}/stream-audio/${songId}`);
          url.searchParams.set('token', token);
          url.searchParams.set('x-service-name', encryptedService);
          url.searchParams.set('x-service-key', encryptedKey);

          // Test access with HEAD request
          await API.head(url.toString());

          // Return the configured URL without headers since audio element can't send them
          return {
              url: url.toString(),
              headers: {
                  'Accept': 'audio/mpeg'
              }
          };

      } catch (error) {
          console.error('Audio fetch error:', error);
          if (error.response?.status === 401) {
              try {
                  await fetchAuth(); // Try refreshing token once
                  return fetchAudioStream(songId); // Retry with fresh token
              } catch (retryError) {
                  console.error('Retry failed:', retryError);
                  throw retryError;
              }
          }
          throw error;
      }
  };


  useEffect(() => {
    sendPage("details")    

    // Set links style
    const style = document.createElement('style');
    style.textContent = `
      .platform-link {
        -webkit-tap-highlight-color: transparent;
        display: inline-block;
        background-color: rgba(0, 0, 0, 0.9);
        opacity: 0.8;
        border-radius: 10px;
        padding: 14px 24px;
        width: 100%;
        text-align: center;
        transition: transform 0.2s ease, background-color 0.2s ease;
      }
      
      .platform-link:active {
        transform: scale(0.98);
        background-color: rgba(40, 40, 40, 0.9) !important;
      }
      
      @media (max-width: 767px) {
        .platform-link {
          padding: 16px 20px;
        }
      }
    `;
    document.head.appendChild(style);
    
    const fetchSongsData = async () => {
      try {        
        // Check for bots first

        setLoading(true);
        await fetchAuth();

        if (typeof slug == 'undefined') {
          setLoading(false);
          return;
        }

        const token = localStorage.getItem("token")

        // Get blog data in a single request
        const blog_data = await API.get(
          `${process.env.REACT_APP_API_URL}/blogs/${songTitle}`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );

        if (blog_data && blog_data.data) {
          const data = blog_data.data;
          setBlogData(data);
          
          // Set meta tags immediately after getting data
          // IMPORTANT: Use .jpg extension and fix the URL construction

          // const previewSongId = data.song || songId;
          // const publicPreviewUrl = `${process.env.REACT_APP_API_URL}/public-preview/${previewSongId}.jpg?v=${Date.now()}`;
          
          // updateMetaTags({
          //   title: data.title || 'Distorise Music',
          //   description: data.content?.substring(0, 150) + '...' || 'Listen to this track on Distorise Music Blog',
          //   imageUrl: publicPreviewUrl,
          //   pageUrl: window.location.href,
          //   type: 'music.song'
          // });
          
          // console.log("Meta tags updated for song details:", data.title, "with URL:", publicPreviewUrl);
        }

        // Continue with image loading
        if (blog_data.data.song) {
          // Start audio stream fetch in parallel
          const audioStreamPromise = fetchAudioStream(blog_data.data.song);
          

          // Get small image for the player
          try {
            const resSmallImage = await API.get(
              `${process.env.REACT_APP_API_URL}/image_sm/${blog_data.data.song}`,
              { responseType: 'blob', headers: { 'Content-Type': 'image/png', 'Authorization': `Bearer ${token}` } }
            );
            
            const blobSmallImage = new Blob([resSmallImage.data], { type: 'image/png' });
            const smallImageUrl = URL.createObjectURL(blobSmallImage);
            setSmallImageUrl(smallImageUrl); // Add this state variable
          } catch (smallImageError) {
            console.error("Error fetching small image, using main image instead:", smallImageError);
            setSmallImageUrl(imageUrl); // Fall back to main image if small image fails
          }

        // Get image
        const resImage = await API.get(
          `${process.env.REACT_APP_API_URL}/image/${blog_data.data.song}`,
          { responseType: 'blob', headers: { 'Content-Type': 'image/png', 'Authorization': `Bearer ${token}` } }
        );
        
        const blobImage = new Blob([resImage.data], { type: 'image/png' });
        const imageUrl = URL.createObjectURL(blobImage);
        setImageUrl(imageUrl);


        // Get audio stream info with headers
        const audioStream = await audioStreamPromise;
        setSongUrl(audioStream);

        }
        
        setLoading(false);         
      } catch (error) {
        console.error("Error fetching song data:", error);
        setLoading(false);
        
        // Fallback to default preview for error cases
        // const defaultPreviewUrl = `${process.env.REACT_APP_API_URL}/default-preview.jpg?v=${Date.now()}`;
        // updateMetaTags({
        //   title: 'Distorise Music',
        //   description: 'Listen to unique music on Distorise Music Blog',
        //   imageUrl: defaultPreviewUrl,
        //   pageUrl: window.location.href,
        //   type: 'music.song'
        // });
      }
    }

    fetchSongsData()    

    const handleContextmenu = e => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
        updateMetaTags(); // Reset to defaults
        document.removeEventListener('contextmenu', handleContextmenu)
        document.head.removeChild(style);
    }
  }, [slug])

  return (
  <Box sx={{
        backgroundColor: '#5C7373',
        backgroundImage: `url(${imageUrl})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed', // This makes it a fixed wallpaper
        width: "100%",
        minHeight: '100vh', // Ensure it covers full viewport height
        justifyContent: "center",
        position: 'relative',
        '&::before': { // Add overlay to make content more readable
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(92, 115, 115, 0.85)', // Semi-transparent overlay
          zIndex: 1
        }
      }}>

      <Box sx={{ position: 'relative', zIndex: 2 }}>

      <Box
        sx={{               
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: "160px",
        }}>
        <Typography
          align="center"
          color={"white"}
          variant="h2"
          sx={{ 
            fontWeight: 900, 
            top: 40, 
            position: 'relative', 
            textShadow: '4px 4px black', 
            fontFamily: 'Light-1',
            // Responsive font sizing
            fontSize: { 
              xs: '1.75rem',  // Small mobile devices (0-600px)
              sm: '2.25rem',  // Tablets (600-900px)
              md: '2.75rem',  // Small laptops (900-1200px)
              lg: '3rem'      // Desktops (1200px+)
            },
            // Handle overflow for very long titles
            wordBreak: 'break-word',
            // Add padding on small screens
            px: { xs: 2, sm: 3, md: 0 },
            // Ensure line height is proportional
            lineHeight: { xs: 1.3, md: 1.2 },
            // Limit max width for extra long titles
            maxWidth: '100%',
            mx: 'auto',
            // Add transition for smooth scaling
            transition: 'font-size 0.3s'
          }}
        >
          {blogData.title}
        </Typography>
      </Box>
      <Container sx={{width: '100%',}}>
      <hr style={{
         height: '12px',
         border: '0',
         width: '100%',
         'box-shadow': 'inset 0 12px 12px -12px rgba(0, 0, 0, 0.5)'}}/>
      </Container>
      
      </Box>

        <MusicPlayer 
          song={songUrl} 
          isLoading={isLoading} 
          slug={slug.split('-').slice(0, -1).join('-')}
          songImage={smallImageUrl || imageUrl} // Pass the small image URL with fallback to main image
          />

      <Container maxWidth={false} sx={{ width: { xs: "80%", sm: "84%", md: "74%" }, borderRadius: 0, }}>
        <hr style={{
          height: '12px',
          border: '0',
          width: '100%',
          'box-shadow': 'inset 0 12px 12px -12px rgba(0, 0, 0, 0.5)'
        }}/>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 1, sm: 2, md: 8 }}
          mt={8}
          sx={{ 
            position: 'relative', 
            zIndex: 2,
            width: '100%', // Full width
            maxWidth: '100%' // Ensure no constraints
          }}>
          <Box 
            flex={3} 
            sx={{
              padding: { xs: "18px 0", md: "18px 0 100px 0" }, // Remove horizontal padding
              top: '-70px',
              position: 'relative',
              width: '100%',
              zIndex: 3
            }}>
          <CardMedia
            sx={{              
              height: "auto",
              width: "100%"
            }}>
                <Typography
                  m={4}
                  align="center"              
                  color={"white"}
                  variant="body2"
                  fontSize={18}
                  sx={{ 
                    fontWeight: 900,
                    position: 'relative',
                    zIndex: 4 }}>
                  <br />
                  <Box sx={{
                    background: "rgba(0, 0, 0, 0.9)",
                    borderRadius: '8px',
                    opacity: 0.8,
                    padding: {xs:3, sm:1, md:3},
                    backdropFilter: 'blur(5px)'}}
                    >
                    <b>{blogData.content}</b>
                  </Box>
                </Typography>
              
                {/* Platform Links Section */}
                <Box 
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    width: '100%',
                    gap: 2,
                    mt: 3,
                    mb: 5
                  }}
                >
                  {(() => {
                    const platforms = [
                      { id: 'soundcloud', link: blogData.soundcloud_link, label: 'SoundCloud' },
                      { id: 'spotify', link: blogData.spotify_link, label: 'Spotify' },
                      { id: 'youtube', link: blogData.youtube_link, label: 'YouTube' },
                      { id: 'bandcamp', link: blogData.bandcamp_link, label: 'Bandcamp' }
                    ].filter(platform => platform.link);
                    
                    const linkCount = platforms.length;
                    
                    // Determine width based on number of links
                    const getWidth = () => {
                      if (linkCount <= 3) {
                        // 3 per row if 3 or fewer links
                        return { xs: '100%', sm: '30%' };
                      } else {
                        // 2 per row if 4 links
                        return { xs: '100%', sm: '45%' };
                      }
                    };
                    
                    return platforms.map(platform => (
                      <Box 
                        key={platform.id}
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          width: getWidth(),
                          m: { xs: 1, md: 1 }
                        }}
                      >
                        <a 
                          href={platform.link}                          
                          target="_blank"
                          rel="noopener noreferrer"
                          className="platform-link"
                          style={{ textDecoration: 'none' }}
                          aria-label={`Open ${platform.label}`}
                        >
                          <Typography 
                            fontSize={{ xs: 18, sm: 20 }}
                            sx={{
                              color: "white",
                              fontFamily: "Light-1",
                              fontWeight: 600,
                              textShadow: '1px 1px rgba(0, 0, 0, 0.5)',
                              '&:hover': {
                                color: "red",
                              }
                            }}
                          >
                            {platform.label}
                          </Typography>
                        </a>
                      </Box>
                    ));
                  })()}
                </Box>
          
          </CardMedia>
          </Box>
        </Stack>
      </Container>

  </Box>
  );
};

export default Details;